import { createElement, Fragment } from "react";
import en from "@/locales/en.json";
import es from "@/locales/es.json";

export const LANGS = [
  { code: "it", label: "Italiano", short: "IT" },
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
];
const CODES = LANGS.map((l) => l.code);
const DICTS = { en, es };
const LOCALES = { it: "it-IT", en: "en-GB", es: "es-ES" };
const KEY = "tc_lang";

function detect() {
  const saved = localStorage.getItem(KEY);
  if (CODES.includes(saved)) return saved;
  const prefs = navigator.languages?.length ? navigator.languages : [navigator.language || "it"];
  for (const p of prefs) {
    const c = String(p).slice(0, 2).toLowerCase();
    if (CODES.includes(c)) return c;
  }
  return "en";
}

let lang = detect();
document.documentElement.lang = lang;

export const getLang = () => lang;
export const _locale = () => LOCALES[lang];

export function setLang(code) {
  if (!CODES.includes(code) || code === lang) return;
  localStorage.setItem(KEY, code);
  window.location.reload();
}

export function _t(key, ...args) {
  const s = (lang !== "it" && DICTS[lang]?.[key]) || key;
  if (!args.length) return s;
  if (args.every((a) => a === null || a === undefined || typeof a !== "object")) {
    return s.replace(/\{(\d+)\}/g, (_, i) => (args[i] === null || args[i] === undefined || args[i] === false ? "" : String(args[i])));
  }
  const parts = s.split(/\{(\d+)\}/).map((p, i) => (i % 2 ? args[Number(p)] : p));
  return createElement(Fragment, null, ...parts);
}
